import "./index.css";
/**
 * @typedef {((e: React.MouseEvent<HTMLButtonElement, MouseEvent>?) => void)} OnClickEventHandler
 */
/**
 * @param {Object} props
 * @param {OnClickEventHandler} props.handleFunction - What to do when click on button
 * @param {boolean} props.isDisabled
 * @param {boolean} props.state - is this switch enabled or not
 * @returns {JSX.Element}
 */
const CommonToggle = ({ state, isDisabled, handleClick }) => {
  return (
    <div
      onClick={(e) => {
        if (!isDisabled) handleClick(e);
      }}
      className={`relative py-padding-button-s ${state ? "bg-positive-act" : "bg-text-disabled"} w-toggle-btn-width ${isDisabled ? "cursor-not-allowed opacity-light-opacity" : "cursor-pointer global-hover-white"} flex z-z-index-base rounded-border-radius-md`}
    >
      <div className=" h-icon-sm w-toggle-btn-width px-padding-button-s">
        <div
          className={`absolute bg-text-primary rounded-full w-icon-sm h-icon-sm ${state ? "toggleanimate-right" : "toggleanimate-left"}`}
        ></div>
      </div>
    </div>
  );
};

export default CommonToggle;
